'use client';

import { useEffect } from 'react';

export default function PWARegister() {
    useEffect(() => {
        // Registrar SW para todo mundo: só usamos para leitura offline (cache da /offline ao baixar capítulo)
        if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
            navigator.serviceWorker
                .register('/sw.js', { 
                    scope: '/',
                    updateViaCache: 'none' // Sempre verificar atualizações
                })
                .then((registration) => {
                    console.log('[PWA] Service Worker registrado com sucesso:', registration.scope);

                    // Verificar atualizações periodicamente (a cada 5 minutos)
                    setInterval(() => {
                        registration.update();
                    }, 5 * 60 * 1000);

                    // Verificar atualizações imediatamente após registro
                    registration.update();
                    
                    // Verificar atualizações quando a página ganha foco
                    const handleFocus = () => {
                        registration.update();
                    };
                    window.addEventListener('focus', handleFocus);
                    
                    return () => {
                        window.removeEventListener('focus', handleFocus);
                    };
                })
                .catch((error) => {
                    console.error('[PWA] Erro ao registrar Service Worker:', error);
                });

            // Listener para quando o service worker está pronto
            navigator.serviceWorker.ready.then(() => {
                console.log('[PWA] Service Worker está pronto');
            });
        }
    }, []);

    return null;
}

